import React from 'react';
import { observer } from "mobx-react";
import { InfoBadgeNs } from 'ReactApp/Types/InfoBadgeNs';
import BadgeV1 from 'ReactApp/Components/BadgeV1/BadgeV1';

type BadgeListV1Props = {
    badges: InfoBadgeNs.InfoBadge[]
}

const BadgeListV1 = observer((props: BadgeListV1Props) => {

    return (
        <div className="badge-list-v1">
            {props.badges.map((badge, index) => (
                <BadgeV1 key={`bv1-${index}`} {...badge} />
            ))}
        </div>
    );

})

export default BadgeListV1;